import React, { useState, useEffect } from "react";

export const Navigation = (props) => {
  const [scrolled, setScrolled] = useState(false);
  const [collapsed, setCollapsed] = useState(true);

  // Handle scroll event to shrink navbar on scroll
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Handle mobile menu toggle
  const toggleNav = () => {
    setCollapsed(!collapsed);
  };

  // Close mobile menu when a link is clicked
  const closeNav = () => {
    if (!collapsed) {
      setCollapsed(true);
    }
  };

  return (
    <nav 
      id="menu" 
      className={`navbar navbar-default navbar-fixed-top ${scrolled ? 'navbar-shrink' : ''}`}
    >
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            onClick={toggleNav}
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
            aria-expanded={!collapsed}
          >
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>
          <a className="navbar-brand page-scroll" href="#page-top">
            fritta-haas.de
          </a>
        </div>

        <div
          className={`collapse navbar-collapse ${!collapsed ? 'in' : ''}`}
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="#history" className="page-scroll" onClick={closeNav}>
                Geschichte
              </a>
            </li>
            <li>
              <a href="#book" className="page-scroll" onClick={closeNav}>
                Kinderbuch
              </a>
            </li>
            <li>
              <a href="#paintings" className="page-scroll" onClick={closeNav}>
                Kunst
              </a>
            </li>
            <li>
              <a href="#events" className="page-scroll" onClick={closeNav}>
                Veranstaltungen
              </a>
            </li>
            <li>
              <a href="#family" className="page-scroll" onClick={closeNav}>
                Familie
              </a>
            </li>
            <li>
              <a href="#press" className="page-scroll" onClick={closeNav}>
                Presse
              </a>
            </li>
            <li>
              <a href="#contact" className="page-scroll" onClick={closeNav}>
                Kontakt
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
